module.exports = __webpack_public_path__ + "img/LOGO DOWNLOAD-03.ad718b47.png";